type UnknownRecord = Record<string, unknown>

function hasWindow(): boolean {
	return typeof window !== 'undefined'
}

function safeLocalStorageGet(key: string): string | null {
	if (!hasWindow()) return null
	try {
		return window.localStorage.getItem(key)
	} catch {
		return null
	}
}

export function isCartDebugEnabled(): boolean {
	if (!hasWindow()) return false
	if ((window as unknown as { __pvCartDebug?: boolean }).__pvCartDebug)
		return true
	const lsFlag = safeLocalStorageGet('pv:debug-cart')
	if (lsFlag === '1' || lsFlag === 'true') return true
	const params = new URLSearchParams(window.location.search)
	const qp = params.get('debugCart')
	return qp === '1' || qp === 'true'
}

export function cartDebug(event: string, payload?: UnknownRecord): void {
	if (!isCartDebugEnabled()) return
	const time = new Date().toISOString()
	if (payload) {
		console.log(`[CartDebug ${time}] ${event}`, payload)
		return
	}
	console.log(`[CartDebug ${time}] ${event}`)
}

export function summarizeCartItems(
	items: Array<{
		id?: number
		key?: string | null
		quantity?: number
		product_title?: string
		title?: string
		product_type?: string
		properties?: UnknownRecord
	}>
): UnknownRecord[] {
	return items.map((item) => {
		const props = item.properties ?? {}
		return {
			id: item.id,
			key: item.key,
			qty: item.quantity,
			title: item.product_title ?? item.title,
			type: item.product_type,
			bundleMembership: Boolean(props._bundle_membership_item),
			alcm: Boolean(props._alcm_item),
			activation: Boolean(props._activation_item),
			gwp: Boolean(props._gwp_item),
			bundleParentId: props._bundle_parent_id,
		}
	})
}

export function summarizeDomCartItems(
	root: ParentNode | null
): UnknownRecord[] {
	if (!root) return []
	const rows = root.querySelectorAll('[data-uc-cart-item]')
	return Array.from(rows).map((row, index) => {
		const input = row.querySelector<HTMLElement>(
			'[data-quantity-variant-id]'
		)
		const variantId = input?.getAttribute('data-quantity-variant-id')
		const name = row
			.querySelector('[data-uc-cart-item-name]')
			?.textContent?.trim()
		return {
			idx: index + 1,
			variantId: variantId ? Number(variantId) : null,
			name,
			optimistic: row.hasAttribute('data-optimistic-item'),
			associated: row.hasAttribute('data-optimistic-associated'),
			sortGroup:
				row.getAttribute('data-optimistic-sort-group') ??
				row.getAttribute('data-sort-group') ??
				null,
			pendingRemoval: row.hasAttribute('data-optimistic-pending-removal'),
			removing: row.classList.contains('cart-item--removing'),
			bundleMembershipUi: row.classList.contains('cart-free_product'),
		}
	})
}

export function summarizeInstructions(instructions: {
	update_required: boolean
	additions: Array<{
		id: number
		quantity?: number
		properties?: UnknownRecord
	}>
	updates: Record<string, number> | Record<number, number>
}): UnknownRecord {
	return {
		updateRequired: instructions.update_required,
		additions: instructions.additions.map((item) => ({
			id: item.id,
			qty: item.quantity,
			bundleMembership: Boolean(item.properties?._bundle_membership_item),
			alcm: Boolean(item.properties?._alcm_item),
			activation: Boolean(item.properties?._activation_item),
			gwp: Boolean(item.properties?._gwp_item),
			bundleParentId: item.properties?._bundle_parent_id,
		})),
		updates: instructions.updates,
	}
}
